import { useEffect, useState } from 'react';
import Banner from "./banner";
import Address from "./addresscheck";
import Plans from "./plans";
import Modem from "./modem";
import Cart from "./cart";
import Services from "./services";
import Queries from "./queries";
import Faq from "./faq";
import React from 'react';
import HeaderBanner from './headerbanner';


// function Home() {
const Home = ({ propdata }) => {

  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  const [vispID, setvispID] = useState(null);
  const [defaultPlan, setDefaultPlan] = useState([]);
  const [defaultModem, setDefaultModem] = useState([]);
  const [checkVispValid, setCheckVispValid] = useState(false);
  const [shippingCharge, setshippingCharge] = useState("0");
  const [gstshippingCharge, setGstShippingCharge] = useState("0");
  const [addressVerify, setAddressVerify] = useState(false);
  const [nbnSessionId, setnbnSessionId] = useState(false);
  const [AvailablePlan, setAvailablePlan] = useState([]);
  const [apiToken, setApiToken] = useState(null);
  const [addressError, setAddressError] = useState(false);


  useEffect(() => {
    //Loading address api on page loading time
    const fetchApiToken = async () => {
      try {

        const response = await fetch(apiUrl + 'nbn_get_autocomplete_address_token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'App-type': 'NBNTSWEB',
          },
          body: JSON.stringify({
            'api-token': apiKey
          }),
        });

        const data = await response.json();

        const tokenValue = data.token;

        setApiToken(tokenValue);
      } catch (error) {
        console.error('Error fetching API token:', error);
      }
    };

    fetchApiToken();
  }, []);


  const getVispHandler = (input, e) => {

    // remove props change variable from address verification
    var vispqual_id = input;
    if (input !== null) { var vispqual_id = input.split('nbn')[0]; }
    setvispID(vispqual_id);

  };


  const getAvailablePlan = (input, e) => {
    setAvailablePlan(input);

  };

  const getDefaultPlan = (input, e) => {
    setDefaultPlan(input);

  };


  const getDefaultModem = (input, e) => {
    setDefaultModem(input);
  };



  const getCheckValidVisp = (input, e) => {
    setCheckVispValid(input);
  };

  const getShippingCharge = (input, e) => {
    setshippingCharge(input);
  };

  const getGstShippingCharge = (input, e) => {
    setGstShippingCharge(input);
  };



  const addressVerified = (input, e) => {
    setAddressVerify(input);

  };


  const passNbnSessionId = (input, e) => {
    setnbnSessionId(input);
  };
  const AddressError =(input,e)=>{
    setAddressError(input)
  }









  return (
    <>
      {/* <Banner title="HOME" description="Get High-Speed Internet At Your Fingertips."/> */}
      <HeaderBanner></HeaderBanner>
      <Address getVispHandler={getVispHandler} addressVerified={addressVerified} passNbnSessionId={passNbnSessionId} getAvailablePlan={getAvailablePlan} tokenValue={apiToken} addressError={addressError} AddressError={AddressError} />
      <Plans vispID={vispID} getDefaultPlan={getDefaultPlan} getCheckValidVisp={getCheckValidVisp} addressVerify={addressVerify} nbnSessionId={nbnSessionId} AvailablePlan={AvailablePlan} />
      <Modem getDefaultModem={getDefaultModem} getShippingCharge={getShippingCharge} getGstShippingCharge={getGstShippingCharge} />
      <Cart defaultPlan={defaultPlan} defaultModem={defaultModem} checkVispValid={checkVispValid} addressVerify={addressVerify} vispID={vispID} nbnSessionId={nbnSessionId} shippingCharge={shippingCharge} gstshippingCharge={gstshippingCharge} AddressError={AddressError} />
      <Services />
      <Faq />
      <Queries />
    </>
  );
}

export default Home;
